export const SET_PROCESS_AREA = "SET_PROCESS_AREA";
export const SET_PROCESS_AREA_NAME = "SET_PROCESS_AREA_NAME";
export const SET_PROCESS_ID = "SET_PROCESS_ID";
export const SET_LOADING_PROCESS = "SET_LOADING_PROCESS";